import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=56fe6f8e&"
import script from "./DetailOrder.vue?vue&type=script&lang=ts&"
export * from "./DetailOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports